type RegistrationTimes = {
  created_at?: string
  email_confirmed_at?: string
  confirmed_at?: string
  last_sign_in_at?: string
}

/** Email OTP accounts may be created minutes before their first verified sign-in. */
export function isInitialSignIn(user: RegistrationTimes, now = Date.now()): boolean {
  const confirmed = Date.parse(user.confirmed_at ?? user.email_confirmed_at ?? user.created_at ?? '')
  const signedIn = Date.parse(user.last_sign_in_at ?? '')
  return Number.isFinite(confirmed) && Number.isFinite(signedIn) &&
    Math.abs(signedIn - confirmed) < 5000 && now >= signedIn && now - signedIn < 60000
}
